import { PathBase } from "@constellation-academy/epic-ui";

export class EmailTemplateEditPath extends PathBase {
	static readonly pathKey = "edit";
}
